import { formatMoney } from "@shopify/theme-currency";

const buildCartItemFragment = ({ cartItem, i }) => {
  const { url, image, product_title, quantity, line_price, original_line_price } = cartItem;
  const splitProductTitle = product_title.split(' - ');
  const originalLinePriceSEl = line_price < original_line_price
    ? `<s>$${formatMoney(original_line_price, '{{amount_no_decimals}}')}</s> `
    : '';

  return `
    <div class="cart-item">
      <div class="cart-item__image-wrapper">
        <a href="${url}">
          <img src="${image}" alt="${product_title}">
        </a>
      </div>
      <a href="${url}" class="cart-item__title">${splitProductTitle[0]}</a>
      <div class="cart-item__remove-wrapper">
        <button class="cart-item__remove" data-line-item="${+i + 1}">
          <svg width="13" height="12" xmlns="http://www.w3.org/2000/svg">
            <path d="M.821 11.096L11.918 0l.771.771L1.593 11.868z"/>
            <path d="M1.593 0l11.096 11.096-.771.772L.82.77z"/>
          </svg>
        </button>
      </div>
      <div class="cart-item__color small caps">${splitProductTitle[1]}</div>
      <div class="cart-item__qty-controls" data-line-item="${+i + 1}">
        <span class="qty-controls__title small caps">qty</span>
        <button class="qty-control qty-control--minus">–</button>
        <input
          type="number"
          name="cartItemCount"
          min="0"
          value="${quantity}"
        >
        <button class="qty-control qty-control--plus">+</button>
      </div>
      <div class="cart-item__price">${originalLinePriceSEl}$${formatMoney(line_price, '{{amount_no_decimals}}')}
      </div>
    </div>
  `
};

const headerCart = ({ resData }) => {
 const message = window.theme.isWholesale
    ? `
      <p data-cart-order-min class="order-threshhold-header">
        ${updateOrderMinMessage({ resData })}
      </p>
    `
    : `
      <p data-cart-shipping-message class="full-cart__shipping">
        ${updateShippingMessage({ resData })}
      </p>
    `
  return `
    <div class="link-group__sub full-cart">
      <div class="full-cart--scroll"></div>
      <div class="full-cart__bottom">
        <div class="full-cart__subtotal">
          <span>subtotal</span>
          <span class="cart-subtotal">$${formatMoney(resData.total_price, '{{amount_no_decimals}}')}</span>
        </div>
        ${message}
        <form action="/checkout" method="post">
          <button data-check-out-button class="full-cart__button button full">
            ${window.theme.isWholesale ? window.theme.cart.placeOrder : window.theme.cart.checkout}
          </button>
        </form>
      </div>
    </div>
  `
}

const emptyCart = ({ message }) => {
  return `
    <div class="link-group__sub empty-cart">
      <span>No items in your shopping bag</span>
      ${message}
    </div>
  `
}

const upsideDownSmiley = `
  <svg width="80" height="80" viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <defs>
      <path id="a" d="M0 0h80v80H0z"/>
    </defs>
    <g fill="none" fill-rule="evenodd">
      <g transform="matrix(1 0 0 -1 0 80)">
        <mask id="b" fill="#fff">
          <use xlink:href="#a"/>
        </mask>
        <path d="M40.001 5.858C21.175 5.858 5.858 21.173 5.858 40c0 18.827 15.317 34.142 34.143 34.142S74.142 58.827 74.142 40c0-18.827-15.315-34.142-34.14-34.142m0 74.142C17.943 80 0 62.058 0 40 0 17.945 17.944 0 40.001 0 62.056 0 80 17.945 80 40c0 22.058-17.944 40-39.999 40" fill="#000" mask="url(#b)"/>
      </g>
      <path d="M33.846 51.796a5.642 5.642 0 1 0-11.284-.001 5.642 5.642 0 0 0 11.284.001M58.462 51.796a5.642 5.642 0 1 0-11.281-.002 5.642 5.642 0 0 0 11.28.002M40.512 14.359c-13.078 0-24.308 9.63-26.125 22.402-.22 1.555.876 2.992 2.45 3.21a2.867 2.867 0 0 0 3.25-2.418c1.42-9.984 10.201-17.514 20.425-17.514 10.225 0 19.008 7.53 20.429 17.514a2.86 2.86 0 0 0 3.248 2.417c1.573-.217 2.67-1.654 2.45-3.209-1.817-12.773-13.05-22.402-26.127-22.402" fill="#000"/>
    </g>
  </svg>
`

export function updateWholeSale({ resData }) {
  if (window.theme.isWholesale) {
    const checkoutButtons = document.querySelectorAll('[data-check-out-button]');
    const orderMinMessage = document.querySelectorAll('[data-cart-order-min]');

    orderMinMessage.forEach(message => {
      if (message) {
        message.innerHTML = updateOrderMinMessage({ resData });
      }
    })

    checkoutButtons.forEach(button => {
      if (button) {
        if (window.theme.customer.isLoggedIn) {
          if (window.theme.customer.isApproved) {
            if ((resData.total_price / 100) < parseInt(window.theme.minWholesaleOrderThreshold, 10)) {
              button.setAttribute('disabled', true);
            } else {
              button.removeAttribute('disabled');
            }
          } else {
            button.setAttribute('disabled', true);
          }
        } else {
          button.removeAttribute('disabled');
        }
      }
    })
  }
}

export function updateOrderMinMessage({ resData }) {
  let orderMinMessage = `Thanks for applying! We're reviewing your application ${upsideDownSmiley}`;

  if (window.theme.customer.isApproved) {
    orderMinMessage = (resData.total_price / 100) >= parseInt(window.theme.minWholesaleOrderThreshold)
    ? ''
    : `Please add $${formatMoney(((parseInt(window.theme.minWholesaleOrderThreshold, 10) * 100) - resData.total_price), '{{amount_no_decimals}}')} to meet our wholesale order minimum ${upsideDownSmiley}`;
  }

  return window.theme.customer.isLoggedIn
    ? orderMinMessage
    : `Please <a href="/account/login">log in</a> to order ${upsideDownSmiley}`;
}

export function updateShippingMessage({ resData }) {
  const { freeShippingThreshold } = document.querySelector('.link-group.cart-nav').dataset;

  return (resData.total_price / 100) >=  parseInt(freeShippingThreshold, 10)
    ? "Ships free within the US!"
    : `Add $${formatMoney(((parseInt(window.theme.minWholesaleOrderThreshold, 10) * 100) - resData.total_price), '{{amount_no_decimals}}')} for free US shipping!`
}

export function checkIfHeaderCartWasEmpty({ resData }) {
  if (resData.item_count > 0) {
    if (document.querySelector('.empty-cart')) {
      document.querySelector('.cart-nav .for-right').classList.add('info-cart');
      document.querySelector('.for-right.info-cart').innerHTML = headerCart({ resData })
      document.querySelector('.full-cart--scroll').innerHTML = buildCartFragment({ resData });
    } else if (document.querySelector('.full-cart--scroll')) {
      document.querySelector('.full-cart--scroll').innerHTML = buildCartFragment({ resData });
    }
  } else {
    if (document.querySelector('.for-right.info-cart')) {
      const message = document.querySelector('.link-group.cart-nav').dataset.emptyCartMessage;
      document.querySelector('.for-right.info-cart').innerHTML = emptyCart({ message });
    }
  }
}

export function buildCartFragment({ resData }) {
  const { item_count, items } = resData;

  let cartFragment = '';

  if (item_count > 0) {
    cartFragment = `${items.map((item,i) => buildCartItemFragment({ cartItem: item, i})).join('')}`;
  }

  return cartFragment
}

export function removeCartItem({ target }) {
  if (target.classList.contains('cart-item__remove')) {
    const cartCounts = document.querySelectorAll('.cart-count');
    const line = target.dataset.lineItem;
    let cartSubtotals;

    deleteCartItem({ line })
    .then(() => {
      getCart()
      .then((resData) => {
        cartCounts.forEach(el => el.innerHTML = resData.item_count);

        if (document.querySelector('.cart-items-scroll')) {
          document.querySelector('.cart-items-scroll').innerHTML = buildCartFragment({ resData });
        }

        checkIfHeaderCartWasEmpty({ resData });
        cartSubtotals = document.querySelectorAll('.cart-subtotal');
        [...cartSubtotals].forEach(el => el.innerHTML = `$${resData.total_price / 100}`);

        updateWholeSale({ resData });

        [...document.querySelectorAll('[ data-cart-shipping-message]')].forEach(shipping => {
          if (shipping) {
            shipping.innerHTML = updateShippingMessage({ resData });
          }
        });
      });
    });
  }
}

export function handleQuantityClick({ target }) {
  if (target.classList.contains('qty-control')) {
    const cartCounts = document.querySelectorAll('.cart-count');
    const line = parseInt(target.parentElement.dataset.lineItem, 10);
    let cartSubtotals;
    let inputEl;
    let quantity;

    if (target.classList.contains('qty-control--minus')) {
      inputEl = target.nextElementSibling;
      inputEl.stepDown();
    }
    else {
      inputEl = target.previousElementSibling;
      inputEl.stepUp();
    }

    quantity = inputEl.value;
    postCartChange({ line, quantity })
    .then(() => {
      getCart()
      .then(resData => {
        cartCounts.forEach(el => el.innerHTML = resData.item_count);

        if (document.querySelector('.cart-items-scroll')) {
          document.querySelector('.cart-items-scroll').innerHTML = buildCartFragment({ resData });
        }

        checkIfHeaderCartWasEmpty({ resData });
        cartSubtotals = document.querySelectorAll('.cart-subtotal');
        [...cartSubtotals].forEach(el => el.innerHTML = `$${resData.total_price / 100}`);

        updateWholeSale({ resData });

        [...document.querySelectorAll('[ data-cart-shipping-message]')].forEach(shipping => {
          if (shipping) {
            shipping.innerHTML = updateShippingMessage({ resData });
          }
        });
      })
    });
  }
}

export function handleQuantityChange({ currentTarget }) {
  const cartCounts = document.querySelectorAll('.cart-count');
  const line = parseInt(currentTarget.parentElement.dataset.lineItem, 10);
  const quantity = currentTarget.value;
  let cartSubtotals;

  postCartChange({ line, quantity })
  .then(() => {
    getCart()
    .then((resData) => {
      cartCounts.forEach(el => el.innerHTML = resData.item_count);

      if (document.querySelector('.cart-items-scroll')) {
        document.querySelector('.cart-items-scroll').innerHTML = buildCartFragment({ resData });
      }

      checkIfHeaderCartWasEmpty({ resData });
      cartSubtotals = document.querySelectorAll('.cart-subtotal');
      [...cartSubtotals].forEach(el => el.innerHTML = `$${resData.total_price / 100}`);

      updateWholeSale({ resData });

      [...document.querySelectorAll('[ data-cart-shipping-message]')].forEach(shipping => {
        if (shipping) {
          shipping.innerHTML = updateShippingMessage({ resData });
        }
      });
    })
  });
}

export function getCart() {
  const credentials = 'same-origin';
  const headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  };

  return window.fetch('/cart.js', { credentials, headers })
  .then(response => response.json())
  .catch((error) => {
    throw new Error(error);
  })
}

export function postCartAdd({ id, quantity }) {
  const headers = { 'Content-Type': 'application/json' };
  const credentials = 'same-origin';
  const method = 'POST';
  const body = JSON.stringify({ id, quantity });

  return window.fetch('/cart/add.js', { headers, credentials, method, body })
  .then(response => response.json())
  .catch((error) => {
    throw new Error(error);
  });
}

export function postCartChange({ line, quantity }) {
  const headers = { 'Content-Type': 'application/json' };
  const credentials = 'same-origin';
  const method = 'POST';
  const body = JSON.stringify({ line, quantity });

  return window.fetch('/cart/change.js', { headers, credentials, method, body })
  .then(response => response.json())
  .catch((error) => {
    throw new Error(error);
  });
}

export function deleteCartItem({ line }) {
  return postCartChange({ line, quantity: 0 })
}
